import React, { createContext, FunctionComponent, useContext, useRef } from "react";
import { Theme, makeStyles, useTheme } from "@material-ui/core";
import { BackgroundSkeleton } from "../../assets/background/background-skeleton";
import { CONTENT_MAX_WIDTH } from "../../theme/theme";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    zIndex: 1,
    minHeight: "100%",
    flex: 1,
    maxWidth: CONTENT_MAX_WIDTH,
    [theme.breakpoints.down("md")]: {
      maxWidth: "100vw",
    },
  },
  background: {
    minHeight: "100%",
    overflowX: "hidden",
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },
  skeleton: {
    position: "absolute",
    zIndex: 0,
    top: 0,
    left: 0,
    height: "100vh",
    maxHeight: "100vh",
  },
}));

interface IBackgroundContext {
  backgroundRef: React.MutableRefObject<HTMLDivElement | null>;
}

const BackgroundContext = createContext<IBackgroundContext>({} as IBackgroundContext);

export const useBackground = () => useContext(BackgroundContext);

interface IBackgroundProps {
  color?: string;
  showSkeleton?: boolean;
}

export const Background: FunctionComponent<IBackgroundProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { color = theme.palette.background.default, showSkeleton = false } = props;
  const backgroundRef = useRef<HTMLDivElement>(null);

  return (
    <BackgroundContext.Provider value={{ backgroundRef }}>
      <div ref={backgroundRef} className={classes.background} style={{ backgroundColor: color }}>
        {showSkeleton && <BackgroundSkeleton className={classes.skeleton} />}
        <div className={classes.content}>{props.children}</div>
      </div>
    </BackgroundContext.Provider>
  );
};
